<template>
  <v-container class="eligibilities-eligibility">
    <v-card-text class="text-xs-left pt-0">
      <v-menu
        :close-on-content-click="false"
        max-width="400"
        max-height="50vh"
        offset-y
        bottom
        right
      >
        <v-btn slot="activator" small color="secondary">
          <v-icon small left>mdi-folder</v-icon>Documents
        </v-btn>
        <v-card dark>
          <EligibilityDocuments :eligibility="eligibility" />
        </v-card>
      </v-menu>
    </v-card-text>

    <v-card-text class="text-xs-center" v-if="eligibility.profile">
      <v-layout row wrap align-center justify-space-between>
        <v-flex xs10 offset-xs1 d-flex md6 offset-md0>
          <v-layout align-center justify-space-around row wrap fill-height>
            <v-flex xs12>
              <v-progress-circular
                size="150"
                :width="10"
                :rotate="-90"
                :value="parseInt(eligibility.completion)"
                :color="eligibility.complete ? 'success' : 'warning'"
              >
                <v-avatar size="140">
                  <img
                    v-if="eligibility.profile && eligibility.profile.avatar"
                    :src="eligibility.profile.avatar"
                  />
                  <img v-else src="/img/missing/avatars/original.png" />
                </v-avatar>
              </v-progress-circular>
            </v-flex>
            <v-flex xs12 class="headline mt-2">
              <router-link
                :to="`/profiles/${eligibility.profile.id}`"
                v-if="eligibility.profile && eligibility.profile.firstName"
                class="name"
              >
                {{ eligibility.profile.firstName }}
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs10 offset-xs1 md5 offset-md0>
          <PersonalDetails :profile="eligibility.profile" :actionItems="eligibility.actionItems" />
        </v-flex>
        <v-flex xs1></v-flex>
      </v-layout>
    </v-card-text>

    <v-card-text ref="eligibility-profile" class="pa-0" v-if="eligibility && eligibility.profile">
      <v-layout row wrap>
        <v-flex xs10 offset-xs1>
          <v-divider />
          <div class="text-xs-center pt-4">
            <div class="headline">
              Biography
            </div>
          </div>

          <div
            v-if="eligibility.profile.biography && eligibility.profile.biography.length > 0"
            class="text-xs-justify"
          >
            <markdown :html="false" :source="eligibility.profile.biography" class="markdown" />
          </div>
        </v-flex>
      </v-layout>
      <Experience
        v-if="eligibility.profile.experiences && eligibility.profile.experiences[0]"
        :experiences="eligibility.profile.experiences"
      />
      <Qualifications
        v-if="
          eligibility.profile.profileQualifications && eligibility.profile.profileQualifications[0]
        "
        :profile="eligibility.profile"
        :qualifications="eligibility.profile.profileQualifications"
        :actionItems="eligibility.actionItems"
      />
      <AdditionalInformation :profile="eligibility.profile" />
    </v-card-text>
  </v-container>
</template>

<script>
import EligibilityDocuments from '@/components/applications_tracker/eligibilities/EligibilityDocuments'
import Experience from '@/components/applications_tracker/profile/Experience'
import Markdown from 'vue-markdown'
import PersonalDetails from '@/components/applications_tracker/profile/PersonalDetails'
import Qualifications from '@/components/applications_tracker/profile/qualifications/Qualifications'
import AdditionalInformation from '@/components/applications_tracker/profile/AdditionalInformation'

export default {
  components: {
    EligibilityDocuments,
    Experience,
    Markdown,
    PersonalDetails,
    Qualifications,
    AdditionalInformation,
  },

  props: ['eligibility'],
}
</script>

<style>
.eligibilities-eligibility a.name {
  text-decoration: none;
}
</style>
